import { readDeepLink } from '../../app/deepLink'
import { useApp, selectPlace } from '../store'
import { METRIC_UNITS, US_UNITS } from '../../shared/units'
import { timeCursor } from '../../app/time/cursor'
import type { TimeModels } from '../../app/time/hourModels'

export const V5_ROUTES = ['/', '/forecast', '/hours', '/days', '/conditions', '/models', '/alerts', '/places', '/settings', '/map', '/radar', '/studio'] as const
export const sectionFor: Readonly<Record<string, string>> = {
  '/forecast': 'v5-main', '/hours': 'v5-hours', '/days': 'v5-days', '/conditions': 'v5-conditions', '/models': 'v5-models', '/alerts': 'v5-alerts',
}
export function v5Route(path: string): string {
  const clean = path.replace(/\/$/, '') || '/'
  return clean === '/index.html' ? '/' : V5_ROUTES.includes(clean as typeof V5_ROUTES[number]) ? clean : 'notfound'
}

/** Applied before the first query, including widget links into map and section routes. */
export function applyV5DeepLink(): void {
  if (v5Route(location.pathname) === 'notfound' || location.pathname.startsWith('/studio')) return
  const query = new URLSearchParams(location.search)
  if (query.get('units') === 'metric') useApp.getState().setUnits(METRIC_UNITS)
  if (query.get('units') === 'us') useApp.getState().setUnits(US_UNITS)
  const place = readDeepLink(location.search)
  if (!place) return
  const label = place.name ?? `${place.latitude.toFixed(2)}, ${place.longitude.toFixed(2)}`
  const id = useApp.getState().addPlace({ latitude: place.latitude, longitude: place.longitude, name: label, label, region: '', zip: null })
  selectPlace(id)
}

let lastTimeLink = ''
export function applyTimeLink(models: TimeModels | null): void {
  if (!models) return
  const raw = new URLSearchParams(location.search).get('t')
  if (!raw || raw === lastTimeLink) return
  const at = Number(raw)
  if (!Number.isFinite(at)) return
  lastTimeLink = raw
  timeCursor.set(at); timeCursor.flush()
}
